<template>
  <footer class="app-footer">
    <section class="social">
      <a href="https://www.facebook.com/BalancedBodyInc/" target="_blank">
        <img
          src="@/assets/images/logo-facebook.svg"
          alt="Facebook logo"
          class="social-logo"
        />
      </a>
      <a href="https://twitter.com/balanced_body" target="_blank">
        <img
          src="@/assets/images/logo-twitter.svg"
          alt="Twitter logo"
          class="social-logo"
        />
      </a>
      <a href="https://www.linkedin.com/company/balanced-body" target="_blank">
        <img
          src="@/assets/images/logo-linkedin.svg"
          alt="LinkedIn logo"
          class="social-logo"
        />
      </a>
      <a href="https://www.instagram.com/balanced_body/" target="_blank">
        <img
          src="@/assets/images/logo-instagram.svg"
          alt="Instagram logo"
          class="social-logo"
        />
      </a>
      <a href="https://www.pinterest.com/balancedbody/" target="_blank">
        <img
          src="@/assets/images/logo-pinterest.svg"
          alt="Pinterest logo"
          class="social-logo"
        />
      </a>
    </section>
    <section class="address">
      Balanced Body 5909 88th Street Sacramento, California 95828 USA<br />
      1-800-PILATES (800)-745-2837) or 916-388-2838
    </section>
    <nav class="footer-nav">
      <a
        href="https://www.pilates.com/company/balanced-body-privacy-policy"
        target="_blank"
      >
        Privacy
      </a>
      <a
        href="https://www.pilates.com/company/balanced-body-legal-notice"
        target="_blank"
      >
        Legal Notice
      </a>
      <a href="https://www.pilates.com/company/careers-with-us" target="_blank">
        Careers
      </a>
    </nav>
  </footer>
</template>

<script>
export default {
  name: "AppFooter"
};
</script>

<style scoped>
.app-footer {
  font-family: var(--roboto);
  height: 200px;
  background-color: var(--text-gray);
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
}

.social-logo {
  padding: 0 10px;
}

.address,
.footer-nav a {
  color: #c4c4c4;
  text-align: center;
  font-size: 10rem;
}

.address {
  margin: 20px 0 10px;
}

.footer-nav a {
  border-right: 1px solid #c4c4c4;
  padding: 0 5px 0 6px;
}

.footer-nav a:last-of-type {
  border-right: none;
}

@media only screen and (min-width: 700px) {
  .app-footer {
    height: 236px;
  }

  .address,
  .footer-nav a {
    font-size: 12rem;
  }
}
</style>
